export default {"src":"/_next/static/media/ico-diamond.9c08ecf5.svg","height":27,"width":32};